import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";
import logoImg from "../assets/logo.webp"; // ← place your logo image in src/assets/

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav>
      <div className="logo">
        <Link to="/" className="logo-link" onClick={closeMenu}>
          <img src={logoImg} alt="Square Feet Marble" className="logo-img" />
          <div className="logo-text">
            <p>BY BHANDARI'S</p>
          </div>
        </Link>
      </div>

      <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
        <li>
          <Link to="/" onClick={closeMenu}>Home</Link>
        </li>
        <li>
          <Link to="/about" onClick={closeMenu}>About</Link>
        </li>
        <li>
          <Link to="/imported-marble" onClick={closeMenu}>Marble</Link>
        </li>
        {/* <li>
          <Link to="/values" onClick={closeMenu}>Values</Link>
        </li> */}
        {/* <li>
          <Link to="/testimonials" onClick={closeMenu}>Testimonials</Link>
        </li> */}
        <li>
          <Link to="/blog" onClick={closeMenu}>Blogs</Link>
        </li>
        <li>
          <Link to="/contact" onClick={closeMenu}>Contact</Link>
        </li>
      </ul>

      <div className={`hamburger ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </nav>
  );
};

export default Navbar;
